/* INTEGY V232 — Quick Shop quantity/Add-to-Cart layout enforcement — 11JUN2026 */
(function(){
  'use strict';
  if (window.INTEGY_V232_QSHOP_ATC_FIX_LOADED) return;
  window.INTEGY_V232_QSHOP_ATC_FIX_LOADED = true;
  function m(q){ try { return window.matchMedia && window.matchMedia(q).matches; } catch(e){ return false; } }
  if (!m('(min-width: 861px)')) return;
  document.documentElement.classList.add('integy-v232-quickshop-atc-fix');
  function qsa(sel, root){ try { return Array.prototype.slice.call((root||document).querySelectorAll(sel)); } catch(e){ return []; } }
  function set(el, prop, val){ if (el && el.style) el.style.setProperty(prop, val, 'important'); }
  function apply(){
    qsa('.modal--quickshop-full,[data-modal-container].modal--quickshop-full').forEach(function(modal){
      modal.classList.add('integy-v232-quantity-fixed');
      qsa('.product-form--atc', modal).forEach(function(atc){
        set(atc,'width','100%'); set(atc,'max-width','100%'); set(atc,'overflow','visible');
      });
      qsa('.product-form__action-wrapper', modal).forEach(function(wrap){
        set(wrap,'display','grid');
        set(wrap,'grid-template-columns','minmax(0, 1fr)');
        set(wrap,'grid-template-rows','auto auto');
        set(wrap,'gap','8px');
        set(wrap,'width','100%');
        set(wrap,'max-width','100%');
        set(wrap,'overflow','visible');
      });
      qsa('.quantity-selector,[data-quantity-selector]', modal).forEach(function(q){
        set(q,'grid-column','1 / -1'); set(q,'grid-row','1'); set(q,'width','100%'); set(q,'max-width','100%'); set(q,'position','relative'); set(q,'z-index','3');
      });
      qsa('.quantity-selector__wrapper', modal).forEach(function(qw){
        set(qw,'display','grid'); set(qw,'grid-template-columns','46px minmax(54px,1fr) 46px'); set(qw,'width','100%'); set(qw,'height','40px'); set(qw,'overflow','hidden');
      });
      qsa('.quantity-selector__button-wrapper,.quantity-selector__button', modal).forEach(function(b){
        set(b,'width','46px'); set(b,'min-width','46px'); set(b,'height','40px'); set(b,'position','relative'); set(b,'z-index','5'); set(b,'pointer-events','auto');
      });
      qsa('.quantity-selector__input', modal).forEach(function(inp){
        set(inp,'width','100%'); set(inp,'height','40px'); set(inp,'text-align','center');
      });
      qsa('.product-form--atc-button,button[name="add"]', modal).forEach(function(btn){
        set(btn,'grid-column','1 / -1'); set(btn,'grid-row','2'); set(btn,'width','100%'); set(btn,'max-width','100%'); set(btn,'height','40px'); set(btn,'min-height','40px'); set(btn,'position','relative'); set(btn,'left','auto'); set(btn,'right','auto'); set(btn,'top','auto'); set(btn,'bottom','auto'); set(btn,'transform','none'); set(btn,'z-index','1');
      });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', apply, {once:true}); else apply();
  window.addEventListener('pageshow', function(){ setTimeout(apply,0); }, {passive:true});
  var obs = new MutationObserver(function(){ apply(); });
  try { obs.observe(document.documentElement, {childList:true, subtree:true}); } catch(e) {}
  setTimeout(apply,250); setTimeout(apply,900);
})();
